export default "__VITE_ASSET__DyUnjDLy__"